import styled from 'styled-components';

import { COLOR, mobile } from '../../../styles/variables';

export const FoldableLayout = styled.section<{ isResponsive?: boolean }>`
    width: 100%;
    height: auto;
    background-color: ${({ isResponsive }) => (isResponsive ? 'transparent' : COLOR.br24.veryLightGrey)};
    font-size: 1rem;
    padding: 0 5%;
`;

export const Trigger = styled.button<{ showDivider?: boolean; isResponsive?: boolean }>`
    outline: none;
    border: none;
    width: 100%;
    height: 3.5rem;
    line-height: 1.25;
    margin: 0;
    background: none;
    display: flex;
    padding: 0;
    font-family: inherit;
    align-items: center;
    text-align: left;
    font-size: 0.85rem;

    @media ${mobile} {
        border-bottom: ${({ showDivider }) => (showDivider ? '1px solid white' : 'none')};
    }
`;

export const TriggerText = styled.div<{ isResponsive?: boolean }>`
    margin-left: ${({ isResponsive }) => (isResponsive ? 0 : '1rem')};
    color: ${COLOR.br24.lightDarkGrey};

    > * {
        margin-bottom: 0 !important;
        margin-top: 0 !important;
    }
`;

export const Content = styled.div<{ isOpen?: boolean; height?: number; isResponsive?: boolean }>`
    max-height: ${({ isOpen, height = 100, isResponsive }) => (isResponsive ? 'unset' : isOpen ? `${height}px` : 0)};
    overflow: hidden;
    transition: max-height 0.25s ease-out;

    @media ${mobile} {
        max-height: ${({ isOpen, height = 100 }) => (isOpen ? `${height}px` : 0)};
    }
`;

export const Inner = styled.div<{ isResponsive?: boolean }>`
    /* Caution: isResponsive is used as "isFooter" here */
    color: ${({ isResponsive }) => (isResponsive ? 'inherit' : COLOR.br24.lightDarkGrey)};
    line-height: ${({ isResponsive }) => (isResponsive ? 'inherit' : 1.25)};
    font-size: ${({ isResponsive }) => (isResponsive ? 'inherit' : '0.85rem')};
    padding-left: ${({ isResponsive }) => (isResponsive ? 0 : '3rem')};
    padding-bottom: 10px;
`;

export const TriggerIcon = styled.div<{
    open?: boolean;
    responsive?: boolean;
    arrowColor?: string;
    arrowBackground?: string;
    arrowRight?: boolean;
}>`
    margin-left: ${({ arrowRight }) => (arrowRight ? 'auto' : '0')};

    svg {
        font-size: 2rem;
        color: ${({ arrowColor }) => (arrowColor ? arrowColor : COLOR.br24.black)};
        background-color: ${({ arrowBackground }) => (arrowBackground ? arrowBackground : COLOR.br24.white)};
        border-radius: 50%;
        padding: 0.25rem;
        margin-left: ${({ responsive }) => (!responsive ? 0 : 'auto')};
        display: ${({ responsive }) => (responsive ? 'none' : 'block')};
        transform: ${({ open }) => (open ? `rotate(-180deg)` : `rotate(0)`)};
        transition: transform 0.25s ease-out;

        @media ${mobile} {
            display: block;
        }
    }
`;
